export default class SystemMessageOption {
    constructor(text, callback, preventClose = false) {
        this.text = text;
        this.callback = callback;
        this.preventClose = preventClose;
    }
}